import { Platform } from 'react-native';
import { analytics, PlaybackEvent, PlaybackEventEmitter, usePlaylistStateStore, } from '@annunciate/core';
import { usePlaybackStateStore, getUUID, getRequestedContent, FileType, } from '@annunciate/core';
import { ensureDownload, getDownloadOrDefault } from '@annunciate/download';
import { pausePlayers } from './onPause';
import { onPlayCurrentAudio, onPlayNewAudio } from '../audio';
import { onPlayNewVideo } from '../video';
import { onOpenExternalLink } from '../other';
const promoteAvailablePlaylist = usePlaylistStateStore.getState().promoteAvailablePlaylist;
export const onStart = async (client, { content, initialPosition, auto = false, } = {}) => {
    const current = usePlaybackStateStore.getState().content;
    if (!content && !current) {
        return;
    }
    let { content: requestedContent, isInContext: isCurrentlyPlaying, type, } = getRequestedContent(content);
    if (!requestedContent) {
        console.warn('No content to play');
        return;
    }
    if (current && !isCurrentlyPlaying) {
        const switchingType = current.asset?.type !== requestedContent.asset?.type;
        await pausePlayers({ content: current, switchingType });
    }
    if (!auto && !isCurrentlyPlaying) {
        await promoteAvailablePlaylist(requestedContent);
    }
    const uuid = (await getUUID(true));
    const download = await getDownloadOrDefault(client, uuid, requestedContent);
    const isDownloaded = download.isDownloaded;
    requestedContent = download.content;
    let updateContent = requestedContent;
    if (isCurrentlyPlaying) {
        if (!(Platform.OS !== "web" && type === FileType.VIDEO)) {
            analytics.emitPlaybackEvent("resumed");
        }
        switch (type) {
            case FileType.AUDIO:
                try {
                    updateContent = usePlaybackStateStore.getState().content;
                    await onPlayCurrentAudio(initialPosition);
                }
                catch (error) {
                    updateContent = await onPlayNewAudio({
                        client,
                        content: requestedContent,
                        initialPosition,
                    });
                }
                break;
            case FileType.EBOOK:
                if (!isDownloaded) {
                    updateContent = await ensureDownload(client, uuid, requestedContent);
                }
                break;
            case FileType.VIDEO:
                updateContent = usePlaybackStateStore.getState().content;
                PlaybackEventEmitter.emit(PlaybackEvent.VIDEO_UNPAUSE);
                break;
            case FileType.OTHER:
            case FileType.IMAGE:
            default:
                await onOpenExternalLink(client, requestedContent);
                break;
        }
    }
    else {
        switch (type) {
            case FileType.AUDIO:
                updateContent = await onPlayNewAudio({
                    client,
                    content: requestedContent,
                    initialPosition,
                    playOnLoad: true,
                });
                break;
            case FileType.EBOOK:
                if (!isDownloaded) {
                    updateContent = await ensureDownload(client, uuid, requestedContent);
                }
                break;
            case FileType.VIDEO:
                updateContent = await onPlayNewVideo(client, requestedContent);
                break;
            case FileType.OTHER:
            case FileType.IMAGE:
            default:
                await onOpenExternalLink(client, requestedContent);
                break;
        }
    }
    usePlaybackStateStore.setState({
        content: updateContent,
        initialPosition: updateContent !== undefined ? initialPosition : undefined,
    });
};
//# sourceMappingURL=onStart.js.map